import { Stack, Text } from '@mantine/core';
import classes from './Credits.module.css';

const TEAM = ['Axel', 'David', 'Jean-Emmanuel', 'Lucas', 'Maxime', 'Maximilien', 'Pauline'];

// Hidden credits — a bowing butler presents the team. One of the two things the "credits" code shows at random.
export function Credits() {
    return (
        <Stack align="center" gap="xs" p="md">
            <div className={classes.butler} role="img" aria-label="A butler bowing">🤵</div>
            <Text fw={700} size="lg">At your service</Text>
            <Text size="sm" c="dimmed">Defenders of the Backoffice</Text>
            <Text fw={500} ta="center" mt="xs">{TEAM.join(' · ')}</Text>
        </Stack>
    );
}
